export { default as EmailSolidIcon } from './EmailSolidIcon';
